import { render, staticRenderFns } from "./404.vue?vue&type=template&id=215b4679&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=215b4679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b4679",
  null
  
)

export default component.exports